import styled from 'styled-components';

export const TabelaContainer = styled.div`
    width: 100%;
    height: 80%;
    margin-top: 20px;
    background: #fff;
    border-radius: 8px;
    padding: 20px;
`
export const TabelaHeader = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #000;
`

export const TabelaHeaderID = styled.div`
    width: 10%;
    border-right: 1px solid #000;
    font-size: 18px;
    text-align: start;
    padding-left: 16px;
`

export const TabelaHeaderNome = styled.div`
    width: 33%;
    border-right: 1px solid #000;
    font-size: 18px;
    padding-left: 16px;

    h1 {
        font-size: 18px;
        font-weight: 600;
    }

    h2 {
        font-size: 14px;
        font-weight: 400;
        color: #5F6368;
    }
`

export const TabelaHeaderInfo = styled.div`
    width: 45%;
    border-right: 1px solid #000;
    font-size: 18px;
    padding-left: 16px;

    h1 {
        font-size: 18px;
        font-weight: 400;
        text-transform: uppercase;
    }

    h2 {
        font-size: 14px;
        font-weight: 400;
        color: #5F6368;
    }
`

export const TabelaHeaderStatus = styled.div`
    width: 15%;
    font-size: 18px;
    padding-left: 16px;
`

export const TabelaBody = styled.div`
    display: flex;
    flex-direction: column;
    height: 85%;
    overflow-y: scroll;
`

export const TabelaLinha = styled.div`    
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    border-bottom: 1px solid #000;
    padding: 10px;
    cursor: pointer;
    
    &:hover {
        background: #F1F3F4;
    }
`

export const StatusBox = styled.div`
    display: flex;
    padding: 4px 8px;
    align-items: center;
    gap: 10px;
    border: 0.7px solid #00ff19;
    background: rgba(0, 255, 25, 0.17);
    justify-content: center;
    font-size: 16px;
    color: #00ff19;
    text-align: center;

    // dependendo do status, muda a cor da borda, e o background (EM ABERTO e AGUARDANDO RETORNO = verde, CONCLUÍDO = vermelho)
    border: ${props => props.status === "EM ABERTO" || props.status === "AGUARDANDO RETORNO" || props.status === "PENDENTE" ? "0.7px solid #00ff19" : "0.7px solid #ff0000"};
    background: ${props => props.status === "EM ABERTO" || props.status === "AGUARDANDO RETORNO"|| props.status === "PENDENTE" ? "rgba(0, 255, 25, 0.17)" : "rgba(255, 0, 0, 0.17)"};
    color: ${props => props.status === "EM ABERTO" || props.status === "AGUARDANDO RETORNO" || props.status === "PENDENTE" ? "#00ff19" : "#ff0000"};

    img svg {
        color: ${props => props.status === "EM ABERTO" || props.status === "AGUARDANDO RETORNO" ? "#00ff19" : "#ff0000"};
    }
`